import React, { useEffect, useState, useRef } from 'react';
import { Bell, User, Menu, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSidebarContext } from './Sidebar';
const notifications = [{
  id: '1',
  type: 'homework',
  title: 'Matematik Ödevi',
  message: 'İntegral konusu ödevini tamamlamayı unutma',
  time: '2 saat önce',
  read: false
}, {
  id: '2',
  type: 'exam',
  title: 'Yaklaşan Sınav',
  message: 'Fizik sınavına 3 gün kaldı',
  time: '5 saat önce',
  read: false
}, {
  id: '3',
  type: 'announcement',
  title: 'Eğitmen Duyurusu',
  message: 'Yarınki ders online yapılacaktır',
  time: '1 gün önce',
  read: true
}];
export function Header() {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const notificationRef = useRef<HTMLDivElement>(null);
  const profileRef = useRef<HTMLDivElement>(null);
  const {
    isOpen,
    setIsOpen
  } = useSidebarContext();
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (notificationRef.current && !notificationRef.current.contains(event.target as Node)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target as Node)) {
        setShowProfileMenu(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="flex items-center justify-center gap-6" data-id="element-472">
      {/* Mobile menu toggle button - Increased size and tap area */}
      <button onClick={() => setIsOpen(true)} className="md:hidden p-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Menüyü aç" data-id="element-473">
        <Menu className="w-6 h-6" data-id="element-474" />
      </button>
      <div className="relative" ref={notificationRef} data-id="element-475">
        <button className="relative" onClick={() => setShowNotifications(!showNotifications)} data-id="element-476">
          <Bell className="w-10 h-10 text-gray-300" data-id="element-477" />
          <span className="absolute -top-1 -right-1 bg-red-500 rounded-full w-6 h-6 text-sm flex items-center justify-center" data-id="element-478">
            3
          </span>
        </button>
        {showNotifications && <div className="fixed inset-x-4 top-32 sm:absolute sm:inset-auto sm:right-0 sm:top-full sm:mt-2 w-auto sm:w-80 z-50" data-id="element-479">
            <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-480">
              <div className="bg-black/90 rounded-xl" data-id="element-481">
                <div className="p-4 border-b border-gray-800" data-id="element-482">
                  <h2 className="text-lg font-semibold" data-id="element-483">Yeni Bildirimler</h2>
                </div>
                <div className="max-h-[400px] overflow-y-auto" data-id="element-484">
                  {notifications.map((notification, index) => <div key={index} className="p-4 border-b border-gray-800/50 hover:bg-white/5 transition-colors" data-id="element-485">
                      <h3 className="font-medium text-purple-400" data-id="element-486">
                        {notification.title}
                      </h3>
                      <p className="text-sm text-gray-400 mt-1" data-id="element-487">
                        {notification.message}
                      </p>
                      <p className="text-xs text-gray-500 mt-2" data-id="element-488">
                        {notification.time}
                      </p>
                    </div>)}
                </div>
                <div className="p-3 border-t border-gray-800" data-id="element-489">
                  <Link to="/bildirimler" onClick={() => setShowNotifications(false)} className="flex items-center justify-center gap-1 w-full p-2 text-center text-sm rounded-lg bg-white/5 hover:bg-white/10 transition-colors" data-id="element-490">
                    <span data-id="element-491">Tüm Bildirimleri Gör</span>
                    <ChevronRight className="w-4 h-4" data-id="element-492" />
                  </Link>
                </div>
              </div>
            </div>
          </div>}
      </div>
      <div className="relative" ref={profileRef} data-id="element-493">
        <button onClick={() => setShowProfileMenu(!showProfileMenu)} className="relative group" data-id="element-494">
          <div className="relative w-14 h-14 rounded-full overflow-hidden ring-2 ring-transparent group-hover:ring-purple-500 transition-all" data-id="element-495">
            <img src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=80&h=80&fit=crop&crop=faces" alt="Profile" className="w-full h-full object-cover" data-id="element-496" />
          </div>
        </button>
        {showProfileMenu && <div className="fixed inset-x-4 top-32 sm:absolute sm:inset-auto sm:right-0 sm:top-full sm:mt-2 w-auto sm:w-64 z-50" data-id="element-497">
            <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-498">
              <div className="bg-black/90 rounded-xl divide-y divide-gray-800" data-id="element-499">
                <div className="p-4" data-id="element-500">
                  <div className="flex items-center gap-3" data-id="element-501">
                    <img src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=80&h=80&fit=crop&crop=faces" alt="Profile" className="w-10 h-10 rounded-full" data-id="element-502" />
                    <div className="flex-1 min-w-0" data-id="element-503">
                      <p className="text-sm font-medium" data-id="element-504">Ahmet Yılmaz</p>
                      <p className="text-xs text-gray-400 truncate" data-id="element-505">
                        8. Sınıf Öğrencisi
                      </p>
                    </div>
                  </div>
                </div>
                <div className="p-2" data-id="element-506">
                  <Link to="/profile" onClick={() => setShowProfileMenu(false)} className="flex items-center gap-2 w-full p-2 text-left text-sm rounded-lg hover:bg-white/5 transition-colors" data-id="element-507">
                    <User className="w-4 h-4" data-id="element-508" />
                    Profili Görüntüle
                  </Link>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}